export enum ColorType {
	Colored = 'Colored',
	BlackAndWhite = 'BlackAndWhite',
}
